import React from 'react'
import { Row, Col, Switch, Input } from 'antd'
import { CreateReq } from 'Store/product/types'
import { AppInput, AppSelect, LabelItem } from 'Components/form'
import styled from 'styled-components'
import { menuUnitDate, ProductStatus } from 'helpers/constanst'
import { StatusTag } from 'Components/utilities'
import { getProductStatus } from 'helpers/format'
import { themeConfig } from 'config'
import en from 'i18n/languages/en'

type Props = {
  formData: CreateReq
  onUpdateData: (val: any, key: string) => void
  isError: (name: string) => boolean
  isRequired: (name: string) => boolean
  isDisabled: (name: string) => boolean
  isHasPackage?: boolean
}

const ProductSetting: React.FunctionComponent<Props> = props => {
  const { formData, onUpdateData, isError, isRequired, isDisabled, isHasPackage = false } = props
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct

  const renderProductStatus = (status: ProductStatus) => (
    <StatusTag isPass={status === ProductStatus.ACTIVE} text={getProductStatus(status)} />
  )

  const renderWanranty = () => {
    const hasWarranty = formData.warranty_status === 'on'
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch
              checked={hasWarranty}
              onChange={(val: boolean) => onUpdateData(val ? 'on' : 'off', 'warranty_status')}
              disabled={isDisabled('warranty_status')}
            />
            &nbsp; &nbsp;
            <LabelItem label={`การรับประกันสินค้า : ${hasWarranty ? 'มี' : 'ไม่มี'}`} />
          </SwitchStyled>
        </Col>
        {hasWarranty && (
          <Col md={12} xs={24}>
            <InputMargin>
              <Input.Group compact>
                <InputGroup>
                  <AppInput
                    type="number"
                    name="product_warranty"
                    label="ระยะเวลาการรับประกัน"
                    placeHolder="ระยะเวลาการรับประกัน"
                    isRequired={hasWarranty}
                    isError={isError('product_warranty')}
                    value={formData.product_warranty}
                    onChange={(val: string, key: string) => onUpdateData(parseInt(val), key)}
                  />
                </InputGroup>
                <InputUnit>
                  <AppSelect
                    name="product_warranty_unit"
                    label="หน่วย"
                    isRequired={isRequired('product_warranty_unit')}
                    isError={isError('product_warranty_unit')}
                    value={formData?.product_warranty_unit?.toString() || ''}
                    onChange={onUpdateData}
                    menu={menuUnitDate}
                    allowClear={false}
                  />
                </InputUnit>
              </Input.Group>
            </InputMargin>
          </Col>
        )}
      </Row>
    )
  }

  const renderRefund = () => {
    const hasRefund = formData.refund_status === 'on'
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch
              checked={hasRefund}
              onChange={(val: boolean) => onUpdateData(val ? 'on' : 'off', 'refund_status')}
              disabled={isDisabled('refund_status')}
            />
            &nbsp; &nbsp;
            <LabelItem label={`รับคืนสินค้า : ${hasRefund ? 'มี' : 'ไม่มี'}`} />
          </SwitchStyled>
        </Col>
        {hasRefund && (
          <Col md={12} xs={24}>
            <InputMargin>
              <Input.Group compact>
                <InputGroup>
                  <AppInput
                    type="number"
                    name="product_refund"
                    label="คืนสินค้าภายใน"
                    placeHolder="ระยะเวลาในการรับคืนสินค้า"
                    isRequired={hasRefund}
                    isError={isError('product_refund')}
                    value={formData.product_refund}
                    onChange={(val: string, key: string) => onUpdateData(parseInt(val), key)}
                  />
                </InputGroup>
                <InputUnit>
                  <AppSelect
                    name="product_refund_unit"
                    label="หน่วย"
                    isRequired={isRequired('product_refund_unit')}
                    isError={isError('product_refund_unit')}
                    value={formData?.product_refund_unit?.toString() || ''}
                    onChange={onUpdateData}
                    menu={menuUnitDate}
                    allowClear={false}
                  />
                </InputUnit>
              </Input.Group>
            </InputMargin>
          </Col>
        )}
      </Row>
    )
  }

  const renderStatus = () => {
    const isActive = formData.status === 'active'
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch
              checked={isActive}
              onChange={(val: boolean) => onUpdateData(val ? 'active' : 'inactive', 'status')}
            />
            &nbsp; &nbsp;
            <LabelItem label={isHasPackage ? 'สถานะสินค้าบนออนไลน์ :' : 'สถานะสินค้า :'} /> &nbsp;
            {renderProductStatus(formData.status)}
          </SwitchStyled>
        </Col>
      </Row>
    )
  }

  const renderTerminalStatus = () => {
    const isActive = formData.status_pos === 'active'
    return (
      <Row justify="start">
        <Col md={24} xs={24}>
          <SwitchStyled>
            <Switch
              checked={isActive}
              onChange={(val: boolean) => onUpdateData(val ? 'active' : 'inactive', 'status_pos')}
            />
            &nbsp; &nbsp;
            <LabelItem label={`สถานะสินค้าบน Terminal :`} /> &nbsp;
            {renderProductStatus(formData.status_pos)}
          </SwitchStyled>
        </Col>
      </Row>
    )
  }

  return (
    <Row>
      {enableProductOnline && (
        <Col md={24} xs={24}>
          {renderWanranty()}
        </Col>
      )}
      {enableProductOnline && (
        <Col md={24} xs={24}>
          {renderRefund()}
        </Col>
      )}

      {enableProductOnline && (
        <Col md={24} xs={24}>
          {renderStatus()}
        </Col>
      )}

      {isHasPackage && (
        <Col md={24} xs={24}>
          {renderTerminalStatus()}
        </Col>
      )}
    </Row>
  )
}

const SwitchStyled = styled.div`
  margin: 10px 0;
`

const InputGroup = styled.div`
  width: 70%;
`

const InputUnit = styled.div`
  width: 29%;
  margin-left: 1%;
`
const InputMargin = styled.div`
  margin-left: 60px;
`

export default ProductSetting
